import { render, staticRenderFns } from "./mediaPublishDetail.vue?vue&type=template&id=656980f1&scoped=true&"
import script from "./mediaPublishDetail.vue?vue&type=script&lang=js&"
export * from "./mediaPublishDetail.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/newMediaDetail/mediaDetails.less?vue&type=style&index=0&id=656980f1&lang=less&scoped=true&"
import style1 from "./mediaPublishDetail.vue?vue&type=style&index=1&id=656980f1&lang=less&scoped=true&"
import style2 from "./mediaPublishDetail.vue?vue&type=style&index=2&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656980f1",
  null
  
)

component.options.__file = "mediaPublishDetail.vue"
export default component.exports